import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import { DownOutlined } from '@ant-design/icons';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import style from './AssignBtn.module.scss';

const AssignBtn: React.FC = () => {
	const { addSelectedApkToRestaurant, IDsSelectedApk, IDsSelectedRestaurants } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const getBtnStatus = () => {
		const countOfOpenTabs = Object.values(IDsSelectedRestaurants).reduce((acc, key) => {
			return key ? acc + 1 : acc;
		}, 0);
		return IDsSelectedApk.length < 1 || countOfOpenTabs === 0;
	};
	const isDisabled = getBtnStatus();

	return (
		<Button
			onClick={addSelectedApkToRestaurant}
			disabled={isDisabled}
			data-test="AssignBtn"
			iconPosition="post"
			icon={<DownOutlined className={style.icon} rotate={270} />}>
			<Text translationNameSpace="listing" translationKey="assignButton" asFragment={true} />
		</Button>
	);
};

export default AssignBtn;
